module.exports = __webpack_public_path__ + "img/id.62c2be0a.svg";